import { useRef, useContext, useState, useEffect } from 'react';

import styles from './DisplayRoomComponent.module.css'

import { GlobalContext } from "../../../contexts/globalContext";
import { ProjectDetailsContext } from '../../../contexts/projectDetailsContext';
import { AddConferenceContext } from '../../../contexts/addConferenceContext';

import { GetMaxZIndex } from '../../../utils/UtilitaryFunctions';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { byPrefixAndName } from '@awesome.me/kit-fe6b9b7683/icons';

import ParticipantDragComponent from './ParticipantDragComponent';
import LightButtonComponent from '../../commons/LightButtonComponent';
import DarkButtonComponent from '../../commons/DarkButtonComponent';

import CornerImage from "../../../graphics/config/colt.png"
import DeskHImage from "../../../graphics/config/masa-h.png"
import DeskVImage from "../../../graphics/config/masa-v.png"
import separator from '../../../graphics/config/picior.png'
import remoteImage from '../../../graphics/Popups/img-remote-users.png'
import bigIcon from '../../../graphics/Popups/img-arrange-part.png'


const DisplayRoomComponent = ({ isInConference = false, shareToParticipant, displayedRoom, deskHeight, allRooms, isRemote, setIsRemote, changeRooms, attachedParticipants, setTablePosition,
    setDisplayedParticipants, allParticipantsRef, setAttachedParticipants, setDisplayedRoom, participantsFilter, setParticipantsFilter, selectedInvites, setSelectedInvites,
    verifyRoomAdmin, setVerifyRoomAdmin, currentRoomAdmin, setCurrentRoomAdmin }) => {

    const { deskData, currentConference, participantsStreams, socketRef, setAlertMessage, appHeight, appWidth, currentParticipant, currentUser } = useContext(GlobalContext);
    const { editConference } = useContext(ProjectDetailsContext)
    const { uniqueModerators, conferenceDetailsForParticipants } = useContext(AddConferenceContext);

    const ref = useRef();
    const tableRef = useRef()
    const currentConferenceRef = useRef();
    const currentTargetRef = useRef()
    const roomDisplayRef = useRef()
    const remotePlusRef = useRef()
    const activeTouchIdRef = useRef(null);

    const [selectedParticipant, setSelectedParticipant] = useState()
    const [isDragging, setIsDragging] = useState(false);
    const [disabled, setDisabled] = useState(true);
    const [deskWidth, setDeskWidth] = useState(deskHeight * 1.215); // 1.215 este raportul dintre lungime si inaltime al imaginii

    const oxDivider = window.innerWidth / appWidth;
    const oyDivider = window.innerHeight / appHeight;

    const separatorRatio = 0.07 // width / height

    useEffect(() => {
        if (conferenceDetailsForParticipants) {
            currentConferenceRef.current = conferenceDetailsForParticipants;
        } else {
            currentConferenceRef.current = currentConference;
        }
    }, [])

    useEffect(() => {
        ref.current.style.opacity = 0;
        ref.current.style.transform = "translate(100px, 0px)";
        ref.current.style.transition = "none";

        setTimeout(() => {
            ref.current.style.transition = "all 0.3s";
            ref.current.style.opacity = 1;
            ref.current.style.transform = "translate(0px, 0px)";

        }, 300);

    }, [displayedRoom, isRemote])

    useEffect(() => {
        setDeskWidth(deskHeight * 1.215)
        setTimeout(() => {
            if (tableRef.current) {
                setTablePosition(tableRef.current.getBoundingClientRect())
            }
        }, 600);
    }, [deskHeight, displayedRoom])

    useEffect(() => {
        if(!isInConference){
            let conference = currentConference ? currentConference : (editConference ? editConference : conferenceDetailsForParticipants)
           
            if (displayedRoom && conference?.roomAdmins[displayedRoom._id] === null) {
                if(editConference && editConference?.type === "Presentation"){
                    // vrem sa avem room admin doar daca dam quick presentation
                    setVerifyRoomAdmin(false)
                } else {
                    setVerifyRoomAdmin(true)
                }
                setCurrentRoomAdmin()
            } else{
                setVerifyRoomAdmin(false)

                if (!isRemote && displayedRoom && currentConferenceRef.current) {
                    socketRef.current.emit("CONFERENCE_GET_ROOM_ADMIN", {
                        roomId: displayedRoom._id,
                        conferenceId: currentConferenceRef.current._id
                    }, callback => {
                        if (!callback.error) {
                            setCurrentRoomAdmin(callback.response)
                        } else {
                            setCurrentRoomAdmin()
                        }
                    })
                }
            }
        }
        

    }, [currentConference, editConference, conferenceDetailsForParticipants, displayedRoom, isRemote])

    useEffect(() => {
        if (isDragging) {
            if (isRemote) {
                window.addEventListener("pointermove", handlePointerMove);
                window.addEventListener("pointerup", handlePointerUp);
            } else {
                window.addEventListener("mousemove", handleMouseMove);
                window.addEventListener("mouseup", handleMouseUp);
                window.addEventListener("touchmove", handleMouseMove);
                window.addEventListener("touchend", handleMouseUp);
            }
        }

        return () => {
            if (isRemote) {
                window.removeEventListener("pointermove", handlePointerMove);
                window.removeEventListener("pointerup", handlePointerUp);
            } else {
                window.removeEventListener("mousemove", handleMouseMove);
                window.removeEventListener("mouseup", handleMouseUp);
                window.removeEventListener("touchmove", handleMouseMove);
                window.removeEventListener("touchend", handleMouseUp);
            }
        };
    }, [isDragging]);

    useEffect(() => {
        if (selectedInvites.length > 0) {
            setDisabled(false)
        } else {
            setDisabled(true)
        }
    }, [selectedInvites])

    const handleMouseDown = (e, assignedParticipant) => {
        if (isInConference) {
            if (assignedParticipant.isOnline && assignedParticipant.participant._id !== currentParticipant?._id) {
                shareToParticipant(assignedParticipant.participant);
            } else if (assignedParticipant.participant._id === currentParticipant?._id) {
                setAlertMessage({ type: "ERROR", message: "You can't share a file to yourself." })
            } else {
                setAlertMessage({ type: "ERROR", message: "You can't share a file to this participant because he is not connected." })
            }
            return;
        }

        if (activeTouchIdRef.current !== null) {
            return;
        }

        if (currentTargetRef.current !== e.currentTarget) {
            currentTargetRef.current = e.currentTarget
        }

        setIsDragging(true);

        if (e.touches) {

            const touch = Array.from(e.touches).find(t =>
                e.currentTarget.contains(document.elementFromPoint(t.clientX, t.clientY))
            );

            if (touch) {
                activeTouchIdRef.current = touch.identifier;

                currentTargetRef.current.startX = touch.clientX;
                currentTargetRef.current.startY = touch.clientY;

                currentTargetRef.current.lastX = touch.clientX;
                currentTargetRef.current.lastY = touch.clientY;
            }
        } else {
            activeTouchIdRef.current = null

            currentTargetRef.current.startX = e.clientX;
            currentTargetRef.current.startY = e.clientY;

            currentTargetRef.current.lastX = e.clientX;
            currentTargetRef.current.lastY = e.clientY;
        }

        currentTargetRef.current.priorStyle = currentTargetRef.current.style

        currentTargetRef.current.style.zIndex = GetMaxZIndex() + 1

        let boundingBox = currentTargetRef.current.getBoundingClientRect();
        let boundingBoxRoomDisplay = ref.current.getBoundingClientRect()

        currentTargetRef.current.style.position = 'fixed';

        currentTargetRef.current.style.left = String((boundingBox.x - boundingBoxRoomDisplay.x) / oxDivider) + "px";
        currentTargetRef.current.style.top = String((boundingBox.y - boundingBoxRoomDisplay.y) / oyDivider) + "px";
    };

    const handleMouseMove = (e) => {

        let newX = 0
        let newY = 0

        if (e.touches) {
            if (activeTouchIdRef.current === null) return;

            const touch = Array.from(e.touches).find(t => t.identifier === activeTouchIdRef.current)

            newX = (touch.clientX - currentTargetRef.current.startX) / oxDivider;
            newY = (touch.clientY - currentTargetRef.current.startY) / oyDivider;

            currentTargetRef.current.lastX = touch.clientX;
            currentTargetRef.current.lastY = touch.clientY;

        } else {
            newX = (e.clientX - currentTargetRef.current.startX) / oxDivider;
            newY = (e.clientY - currentTargetRef.current.startY) / oyDivider;

            currentTargetRef.current.lastX = e.clientX;
            currentTargetRef.current.lastY = e.clientY;
        }

        currentTargetRef.current.style.transform = `translate(${newX}px, ${newY}px)`;
    };

    const handleMouseUp = (e) => {


        if (e.changedTouches) {
            if (activeTouchIdRef.current === null) return;

            const touch = Array.from(e.changedTouches).find(t => t.identifier === activeTouchIdRef.current);

            if (!touch) {
                return;
            }
        }

        setIsDragging(false);
        activeTouchIdRef.current = null

        let mouseX = currentTargetRef.current.lastX;
        let mouseY = currentTargetRef.current.lastY;

        const targetRect = tableRef.current.getBoundingClientRect();

        if (isOverlapping(mouseX, mouseY, targetRect) && !isRemote) {

            let tableWidth = targetRect.width / oxDivider
            let tableHeight = targetRect.height / oyDivider

            let insidePosX = (mouseX - targetRect.x) / oxDivider
            let insidePosY = (mouseY - targetRect.y) / oyDivider

            console.log("targer rect", targetRect);

            let desk = null

            if (insidePosY <= deskHeight) {

                let posNumber = Math.floor((insidePosX - deskHeight) / deskWidth)
                if (posNumber <= displayedRoom.desks_north.length) desk = displayedRoom.desks_north[posNumber]

            } else if (insidePosY >= tableHeight - deskHeight) {

                let posNumber = Math.floor((insidePosX - deskHeight) / deskWidth)
                if (posNumber <= displayedRoom.desks_north.length) desk = displayedRoom.desks_south[posNumber]

            } else if (insidePosX <= deskHeight) {

                let posNumber = Math.floor((insidePosY - deskHeight) / deskWidth)
                if (posNumber <= displayedRoom.desks_north.length) desk = displayedRoom.desks_west[posNumber]

            } else if (insidePosX >= tableWidth - deskHeight) {

                let posNumber = Math.floor((insidePosY - deskHeight) / deskWidth)
                if (posNumber <= displayedRoom.desks_north.length) desk = displayedRoom.desks_east[posNumber]

            }

            console.log("insidePosX",insidePosX, "insidePosY", insidePosY, "deskWidth", deskWidth, "deskHeight", deskHeight);

            if (desk) {
                deskChanged(desk)
                return;
            }
        }

        const displayRect = roomDisplayRef.current.getBoundingClientRect();

        if (!isOverlapping(mouseX, mouseY, displayRect)) {


            let displayX = displayRect.x
            let displayY = displayRect.y

            if (mouseX <= displayX && mouseY >= displayY) {
                removeParticipant(selectedParticipant, selectedParticipant.desk)
                return;
            }

        }

        currentTargetRef.current.style.transform = `translate(${0}px, ${0}px)`;

        currentTargetRef.current.style.position = 'absolute';
        currentTargetRef.current.style.left = "0px";
        currentTargetRef.current.style.top = "0px";


        currentTargetRef.current.style.zIndex = 0


    };

    const handlePointerDown = (e, assignedParticipant) => {
        if (isInConference) {
            if (assignedParticipant.isOnline && assignedParticipant.participant._id !== currentParticipant?._id) {
                shareToParticipant(assignedParticipant.participant);
            } else if (assignedParticipant.participant._id === currentParticipant?._id) {
                setAlertMessage({ type: "ERROR", message: "You can't share a file to yourself." });
            } else {
                setAlertMessage({ type: "ERROR", message: "You can't share a file to this participant because they are not connected." });
            }
            return;
        }

        if (activeTouchIdRef.current !== null) return;

        if (currentTargetRef.current !== e.currentTarget) {
            currentTargetRef.current = e.currentTarget;
        }

        setIsDragging(true);
        activeTouchIdRef.current = e.pointerId;

        currentTargetRef.current.startX = e.clientX;
        currentTargetRef.current.startY = e.clientY;
        currentTargetRef.current.lastX = e.clientX;
        currentTargetRef.current.lastY = e.clientY;

        currentTargetRef.current.priorStyle = currentTargetRef.current.style;
        currentTargetRef.current.style.zIndex = GetMaxZIndex() + 1;

        const boundingBox = currentTargetRef.current.getBoundingClientRect();
        const boundingBoxRoomDisplay = ref.current.getBoundingClientRect();

        currentTargetRef.current.style.position = "fixed";
        currentTargetRef.current.style.left = `${(boundingBox.x - boundingBoxRoomDisplay.x) / oxDivider}px`;
        currentTargetRef.current.style.top = `${(boundingBox.y - boundingBoxRoomDisplay.y) / oyDivider}px`;
    };

    const handlePointerMove = (e) => {
        if (!isDragging || activeTouchIdRef.current !== e.pointerId) return;

        const newX = (e.clientX - currentTargetRef.current.startX) / oxDivider;
        const newY = (e.clientY - currentTargetRef.current.startY) / oyDivider;

        currentTargetRef.current.lastX = e.clientX;
        currentTargetRef.current.lastY = e.clientY;

        currentTargetRef.current.style.transform = `translate(${newX}px, ${newY}px)`;
    };

    const handlePointerUp = (e) => {
        if (activeTouchIdRef.current !== e.pointerId) return;

        setIsDragging(false);
        activeTouchIdRef.current = null;

        const { startX, startY, lastX, lastY } = currentTargetRef.current;

        if (Math.abs(lastX - startX) < 5 && Math.abs(lastY - startY) < 5) {
            currentTargetRef.current.style.transform = `translate(0px, 0px)`;
            currentTargetRef.current.style.position = "absolute";
            currentTargetRef.current.style.left = "0px";
            currentTargetRef.current.style.top = "0px";
            currentTargetRef.current.style.zIndex = 0;

            const id = selectedParticipant.participant._id;

            if (selectedInvites.includes(id)) {
                setSelectedInvites(prev => prev.filter(invite => invite !== id));
            } else {
                setSelectedInvites(prev => [...prev, id]);
            }

            return;
        }

        let mouseX = currentTargetRef.current.lastX;
        let mouseY = currentTargetRef.current.lastY;

        const displayRect = roomDisplayRef.current.getBoundingClientRect();

        if (!isOverlapping(mouseX, mouseY, displayRect)) {
            let displayX = displayRect.x;
            let displayY = displayRect.y;

            if (mouseX <= displayX && mouseY >= displayY) {
                removeParticipant(selectedParticipant, selectedParticipant.desk);
                return;
            }
        }

        currentTargetRef.current.style.transform = `translate(0px, 0px)`;
        currentTargetRef.current.style.position = "absolute";
        currentTargetRef.current.style.left = "0px";
        currentTargetRef.current.style.top = "0px";
        currentTargetRef.current.style.zIndex = 0;
    };

    const isOverlapping = (mouseX, mouseY, rect) => {
        return (
            mouseX >= rect.left &&
            mouseX <= rect.right &&
            mouseY >= rect.top &&
            mouseY <= rect.bottom
        );
    };

    const deskChanged = (desk) => {
        const availableDesk = desk

        // cautam daca unul dintre participanti este online
        let switchParticipant = attachedParticipants.find(
            (attached) => attached.desk?._id === availableDesk._id || attached.desk === availableDesk._id
        );

        if (switchParticipant) {
            switchParticipant.isOnline = switchParticipant?.desk._id === deskData?._id && currentConference?.status === "Active" ? true : false;

            const videos = participantsStreams.find((stream) => stream.participant._id === switchParticipant?.participant._id)

            if (videos) {
                switchParticipant.isOnline = true
            }

            if (switchParticipant?.isOnline || switchParticipant.participant._id === currentConference?.moderatedBy) {
                if (switchParticipant)
                    setAlertMessage({ type: "ERROR", message: "One or both of the participants are already in the conference." });

                currentTargetRef.current.style.transform = `translate(${0}px, ${0}px)`;

                currentTargetRef.current.style.position = 'absolute';
                currentTargetRef.current.style.left = "0px";
                currentTargetRef.current.style.top = "0px";

                currentTargetRef.current.style.zIndex = 0
                return;
            }
        }

        if (selectedParticipant.isOnline || selectedParticipant.participant._id === currentConference?.moderatedBy) {
            setAlertMessage({ type: "ERROR", message: "The participant is already in the conference." });

            currentTargetRef.current.style.transform = `translate(${0}px, ${0}px)`;

            currentTargetRef.current.style.position = 'absolute';
            currentTargetRef.current.style.left = "0px";
            currentTargetRef.current.style.top = "0px";

            currentTargetRef.current.style.zIndex = 0
            return;
        }


        socketRef.current.emit("CONFERENCE_SWITCH_PARTICIPANTS_ON_DESKS", {
            deskId1: selectedParticipant.desk._id,
            deskId2: availableDesk._id,
            conferenceId: currentConferenceRef.current._id
        }, callback => {
            if (!callback.error) {
                setAttachedParticipants(callback.response)

                if (selectedParticipant.desk._id) {
                    socketRef.current.emit("DESK_PARTICIPANT_CHANGED", selectedParticipant.desk._id);
                }

                if (availableDesk._id) {
                    socketRef.current.emit("DESK_PARTICIPANT_CHANGED", availableDesk._id);
                }

                currentTargetRef.current.style.transform = `translate(${0}px, ${0}px)`;

                currentTargetRef.current.style.position = 'absolute';
                currentTargetRef.current.style.left = "0px";
                currentTargetRef.current.style.top = "0px";

                currentTargetRef.current.style.zIndex = 0
            }
        })

    }

    const removeParticipant = (assignedParticipant, desk) => {
        if (uniqueModerators.some(moderator => moderator._id === assignedParticipant.participant._id) || assignedParticipant.participant._id === currentConference?.moderatedBy || 
            (assignedParticipant.participant.presentation && assignedParticipant.participant.presentation === editConference?._id)) {
            if(uniqueModerators.some(moderator => moderator._id === assignedParticipant.participant._id)){
                setAlertMessage({ type: "ERROR", message: "You can't remove a participant that is a moderator of the conference." })
            } else if( assignedParticipant.participant._id === currentConference?.moderatedBy){
                setAlertMessage({ type: "ERROR", message: `This conference is moderated by ${assignedParticipant.participant.name}` })
            } else {
                setAlertMessage({ type: "ERROR", message: `${assignedParticipant.participant.name} is a lightning speaker for this presentation. ` })

            }

            currentTargetRef.current.style.transform = `translate(${0}px, ${0}px)`;

            currentTargetRef.current.style.position = 'absolute';
            currentTargetRef.current.style.left = "0px";
            currentTargetRef.current.style.top = "0px";


            currentTargetRef.current.style.zIndex = 0
            return;
        } else {
            socketRef.current.emit("CONFERENCE_REMOVE_PARTICIPANT_FROM_DESK", {
                attachedParticipantId: assignedParticipant._id
            }, callback => {
                if (!callback.error) {
                    if (desk) {
                        socketRef.current.emit("DESK_PARTICIPANT_CHANGED", desk._id);
                    }
                    setAttachedParticipants(callback.response)
                    allParticipantsRef.current = [...allParticipantsRef.current, assignedParticipant.participant]
                    if (participantsFilter === "ALL") {
                        setDisplayedParticipants((prevParticipants) => [
                            ...prevParticipants,
                            assignedParticipant.participant
                        ]);
                    }
                    setParticipantsFilter('ALL')
                    if (selectedInvites.includes(selectedParticipant.participant._id)) {
                        const filteredInvites = selectedInvites.filter(invite => invite !== selectedParticipant.participant._id)
                        setSelectedInvites(filteredInvites)
                    }
                    if (selectedParticipant.emailSent) {
                        setAlertMessage({ type: "WARNING", message: "You removed a participant that was previously sent an email invitation." })
                    }
                }
            })
        }
    }

    const selectAllInvites = () => {
        let allParticipantsIds = attachedParticipants.map(attachedPart => attachedPart.participant._id)
        setSelectedInvites(allParticipantsIds)
    }

    const deselectAllInvites = () => {
        setSelectedInvites([])
    }

    const sendInvites = () => {
        setDisabled(true)
        socketRef.current.emit("CONFERENCE_SEND_INVITATION", selectedInvites, attachedParticipants[0].conference, (callback) => {
            if (!callback.error) {
                setAlertMessage({ type: "SUCCESS", message: "The invites were successfully sent." })
                setAttachedParticipants(callback.newAttachedParticipants)
                setSelectedInvites([])
            } else {
                setAlertMessage({ type: "ERROR", message: "Error while sending the emails. Try again." })
            }

        });
    }


    return (
        <>
            <div className={styles.roomsTab}>
                {allRooms?.map((room) => <div key={room._id} className={!isRemote && room._id === displayedRoom._id ? styles.roomCardSelected : styles.roomCard} style={{ top: isRemote ? 33 : 33 }}
                    onClick={() => changeRooms(room)}
                >
                    <div style={{ fontSize: 28, lineHeight: 1, fontWeight: "normal", marginBottom: 6 }}>{room.location.name}</div>
                    {room.name}
                </div>)}
                {!isInConference && <div className={isRemote ? styles.roomCardSelected : styles.roomCard} style={{ height: 90, top: !isRemote ? 33 : 33 }} onClick={() => {
                    setIsRemote(true)
                    setDisplayedRoom(null)
                }}>
                    {currentConferenceRef.current?.type !== "Meeting" && <div>Remote users</div>}
                    {currentConferenceRef.current?.type === "Meeting" && <div>Invite users</div>}
                </div>}

            </div>
            <div ref={roomDisplayRef} className={styles.roomDisplay}>
                {!isRemote && <div ref={ref} style={{ height: "100%", width: "100%", display: "flex", justifyContent: "center", alignItems: "center" }}>
                    <div className={styles.imgDiv}>
                        {verifyRoomAdmin ? <>
                            <div className={styles.adminBox} style={{ borderColor: "#33FFC8" }} />
                            <div className={styles.placeText} style={{ color: "#FFFFFFE6" }}> Choose room admin </div>
                            <div className={styles.imgText} style={{ color: "#FFFFFF99" }}> Drag and drop the selected person in the center box.</div>
                        </> : <>
                            {isInConference ? <>
                                <img src={bigIcon} alt={"img"} className={styles.img} />
                                <div className={styles.placeText}>Select participant</div>
                                <div className={styles.imgText}>Tap participant for handover.</div>

                            </> : <>
                                {currentRoomAdmin ? <div className={styles.adminBox}>
                                    <ParticipantDragComponent user={currentRoomAdmin} />
                                </div> : <img src={bigIcon} alt={"img"} className={styles.img} />}
                                <div className={styles.placeText}>Place participants</div>
                                <div className={styles.imgText}>Select and drag participants to their designated desks.</div>
                            </>}

                        </>}

                    </div>
                    <div
                        ref={tableRef}
                        style={{ opacity: verifyRoomAdmin ? 0.5 : (!currentRoomAdmin || currentRoomAdmin?._id === currentUser?._id || currentRoomAdmin?._id === currentParticipant?._id) ? 1 : 0.5 }}
                    >
                        <div style={{ display: "flex", flexDirection: "row" }}>
                            {
                                displayedRoom?.desks_north.length > 0 && displayedRoom?.desks_west.length > 0 && <>
                                    <img alt={"img"} src={CornerImage} height={deskHeight} />
                                    <img alt={"img"} src={separator} height={deskHeight} />
                                </>
                            }
                            {displayedRoom?.desks_north.map((desk) => {
                                let assignedParticipant = attachedParticipants.find(
                                    (attached) => attached.desk?._id === desk._id || attached.desk === desk._id
                                );

                                if (assignedParticipant) {
                                    assignedParticipant.isOnline = assignedParticipant?.desk._id === deskData?._id && currentConference?.status === "Active" ? true : false;

                                    const videos = participantsStreams.find((stream) => stream.participant._id === assignedParticipant?.participant._id)

                                    if (videos) {
                                        assignedParticipant.isOnline = true
                                    }
                                }
                                return (
                                    <div key={desk.number} style={{ position: "relative", display: "flex", justifyContent: "center" }}>
                                        {!assignedParticipant &&
                                            <span className={styles.deskNumber} style={{ width: deskHeight / 4, height: deskHeight / 4, top: deskHeight / 1.9 }}>{desk.number}</span>
                                        }
                                        {assignedParticipant &&
                                            <div onMouseDown={(e) => {
                                                if (!currentRoomAdmin || currentRoomAdmin?._id === currentUser?._id || currentRoomAdmin?._id === currentParticipant?._id) {
                                                    setSelectedParticipant(assignedParticipant)
                                                    handleMouseDown(e, assignedParticipant)
                                                }

                                            }}
                                                onTouchStart={(e) => {
                                                    if (!currentRoomAdmin || currentRoomAdmin?._id === currentUser?._id || currentRoomAdmin?._id === currentParticipant?._id) {
                                                        setSelectedParticipant(assignedParticipant)
                                                        handleMouseDown(e, assignedParticipant)
                                                    }
                                                }}
                                                style={{
                                                    top: 0, left: 0, width: deskWidth, height: deskHeight, position: "absolute",
                                                    touchAction: currentParticipant?._id === assignedParticipant.participant._id ? "none" : "",
                                                    userSelect: currentParticipant?._id === assignedParticipant.participant._id ? "none" : "",
                                                    pointerEvents: currentParticipant?._id === assignedParticipant.participant._id ? "none" : "",
                                                }}
                                            >
                                                <ParticipantDragComponent user={assignedParticipant.participant} isOnline={assignedParticipant.isOnline} scale={deskHeight / 570}
                                                    deskNumber={desk.number} />
                                            </div>
                                        }
                                        <img alt={"img"} draggable={false} src={DeskHImage} height={deskHeight} />
                                        <img alt={"img"} src={separator} height={deskHeight} />
                                    </div>
                                )
                            })}
                            {
                                displayedRoom?.desks_north.length > 0 && displayedRoom?.desks_east.length > 0 && <>
                                    <img alt={"img"} src={CornerImage} height={deskHeight} style={{ transform: "rotate(90deg)" }} />
                                </>
                            }
                        </div>
                        <div style={{ display: "flex", flexDirection: "row" }}>
                            <div style={{ width: "50%", display: "flex", justifyContent: "start" }}>
                                <div style={{ display: "flex", flexDirection: "column" }}>
                                    {displayedRoom?.desks_west.map((desk, index) => {
                                        let assignedParticipant = attachedParticipants.find(
                                            (attached) => attached.desk?._id === desk._id || attached.desk === desk._id
                                        );

                                        if (assignedParticipant) {
                                            assignedParticipant.isOnline = assignedParticipant?.desk._id === deskData?._id && currentConference?.status === "Active" ? true : false;

                                            const videos = participantsStreams.find((stream) => stream.participant._id === assignedParticipant?.participant._id)

                                            if (videos) {
                                                assignedParticipant.isOnline = true
                                            }
                                        }
                                        return (
                                            <div key={desk.number} style={{ position: "relative", display: "flex", flexDirection: "column" }}>
                                                {!assignedParticipant &&
                                                    <span className={styles.deskNumber} style={{ width: deskHeight / 4, height: deskHeight / 4, left: deskHeight / 1.9, top: "39.3%" }}>
                                                        {desk.number}
                                                    </span>
                                                }
                                                {assignedParticipant &&
                                                    <div onMouseDown={(e) => {
                                                        if (!currentRoomAdmin || currentRoomAdmin?._id === currentUser?._id || currentRoomAdmin?._id === currentParticipant?._id) {
                                                            setSelectedParticipant(assignedParticipant)
                                                            handleMouseDown(e, assignedParticipant)
                                                        }
                                                    }}
                                                        onTouchStart={(e) => {
                                                            if (!currentRoomAdmin || currentRoomAdmin?._id === currentUser?._id || currentRoomAdmin?._id === currentParticipant?._id) {
                                                                setSelectedParticipant(assignedParticipant)
                                                                handleMouseDown(e, assignedParticipant)
                                                            }
                                                        }}
                                                        style={{
                                                            top: 0, left: 0, width: deskHeight, height: deskWidth, position: "absolute",
                                                            touchAction: currentParticipant?._id === assignedParticipant.participant._id ? "none" : "",
                                                            userSelect: currentParticipant?._id === assignedParticipant.participant._id ? "none" : "",
                                                            pointerEvents: currentParticipant?._id === assignedParticipant.participant._id ? "none" : "",
                                                        }}
                                                    >
                                                        <ParticipantDragComponent user={assignedParticipant.participant} isOnline={assignedParticipant.isOnline} scale={deskHeight / 570}
                                                            deskNumber={desk.number} />
                                                    </div>
                                                }
                                                {index === 0 && <div style={{ height: deskHeight * separatorRatio }}>
                                                    <img alt={"img"} src={separator} height={deskHeight} style={{
                                                        transform: `rotate(-90deg) translate(0px, ${- deskHeight * separatorRatio}px)`,
                                                        transformOrigin: "top right"
                                                    }}
                                                    />
                                                </div>}
                                                <img alt={"img"} draggable={false} src={DeskVImage} width={deskHeight} />
                                                <div style={{ height: deskHeight * separatorRatio }}>
                                                    <img alt={"img"} src={separator} height={deskHeight} style={{
                                                        transform: `rotate(-90deg) translate(0px, ${- deskHeight * separatorRatio}px)`,
                                                        transformOrigin: "top right"
                                                    }}
                                                    />
                                                </div>
                                            </div>
                                        )
                                    })}
                                </div>
                            </div>
                            <div style={{ width: "50%", display: "flex", justifyContent: "end" }}>
                                <div style={{ display: "flex", flexDirection: "column" }}>
                                    {displayedRoom?.desks_east.map((desk, index) => {
                                        let assignedParticipant = attachedParticipants.find(
                                            (attached) => attached.desk?._id === desk._id || attached.desk === desk._id
                                        );

                                        if (assignedParticipant) {
                                            assignedParticipant.isOnline = assignedParticipant?.desk._id === deskData?._id && currentConference?.status === "Active" ? true : false;

                                            const videos = participantsStreams.find((stream) => stream.participant._id === assignedParticipant?.participant._id)

                                            if (videos) {
                                                assignedParticipant.isOnline = true
                                            }
                                        }
                                        return (
                                            <div key={desk.number} style={{ position: "relative", display: "flex", flexDirection: "column" }}>
                                                {index === 0 && <div style={{ height: deskHeight * separatorRatio }}>
                                                    <img alt={"img"} src={separator} height={deskHeight} style={{
                                                        transform: `rotate(90deg) translate(0px, ${- deskHeight}px)`,
                                                        transformOrigin: "top left"
                                                    }}
                                                    />
                                                </div>}
                                                <img alt={"img"} draggable={false} src={DeskVImage} width={deskHeight} style={{ transform: "rotate(180deg)" }} />
                                                <div style={{ height: deskHeight * separatorRatio }}>
                                                    <img alt={"img"} src={separator} height={deskHeight} style={{
                                                        transform: `rotate(90deg) translate(0px, ${- deskHeight}px)`,
                                                        transformOrigin: "top left"
                                                    }}
                                                    />
                                                </div>
                                                {!assignedParticipant &&
                                                    <span className={styles.deskNumber} style={{ width: deskHeight / 4, height: deskHeight / 4, left: deskHeight / 5, top: "39.3%" }}>
                                                        {desk.number}
                                                    </span>
                                                }
                                                {assignedParticipant &&
                                                    <div onMouseDown={(e) => {
                                                        if (!currentRoomAdmin || currentRoomAdmin?._id === currentUser?._id || currentRoomAdmin?._id === currentParticipant?._id) {
                                                            setSelectedParticipant(assignedParticipant)
                                                            handleMouseDown(e, assignedParticipant)
                                                        }
                                                    }}
                                                        onTouchStart={(e) => {
                                                            if (!currentRoomAdmin || currentRoomAdmin?._id === currentUser?._id || currentRoomAdmin?._id === currentParticipant?._id) {
                                                                setSelectedParticipant(assignedParticipant)
                                                                handleMouseDown(e, assignedParticipant)
                                                            }
                                                        }}
                                                        style={{
                                                            top: 0, left: 0, width: deskHeight, height: deskWidth, position: "absolute",
                                                            touchAction: currentParticipant?._id === assignedParticipant.participant._id ? "none" : "",
                                                            userSelect: currentParticipant?._id === assignedParticipant.participant._id ? "none" : "",
                                                            pointerEvents: currentParticipant?._id === assignedParticipant.participant._id ? "none" : "",
                                                        }}
                                                    >
                                                        <ParticipantDragComponent user={assignedParticipant.participant} isOnline={assignedParticipant.isOnline} scale={deskHeight / 570}
                                                            deskNumber={desk.number} />
                                                    </div>
                                                }
                                            </div>
                                        )
                                    })}
                                </div>
                            </div>
                        </div>
                        <div style={{ display: "flex" }}>
                            {
                                displayedRoom?.desks_south.length > 0 && displayedRoom?.desks_west.length > 0 && <>
                                    <img alt={"img"} src={CornerImage} height={deskHeight} style={{ transform: "rotate(-90deg)" }} />
                                    <img alt={"img"} src={separator} height={deskHeight} style={{ position: "relative", transform: "rotate(180deg)" }} />
                                </>
                            }
                            {displayedRoom?.desks_south.map((desk) => {
                                let assignedParticipant = attachedParticipants.find(
                                    (attached) => attached.desk?._id === desk._id || attached.desk === desk._id
                                );

                                if (assignedParticipant) {
                                    assignedParticipant.isOnline = assignedParticipant?.desk._id === deskData?._id && currentConference?.status === "Active" ? true : false;

                                    const videos = participantsStreams.find((stream) => stream.participant._id === assignedParticipant?.participant._id)

                                    if (videos) {
                                        assignedParticipant.isOnline = true
                                    }
                                }
                                return (
                                    <div key={desk.number} style={{ position: "relative", display: "flex", justifyContent: "center" }}>
                                        <img alt={"img"} src={DeskHImage} draggable={false} height={deskHeight} style={{ transform: "rotate(180deg)" }} />
                                        <img alt={"img"} src={separator} height={deskHeight} style={{ position: "relative", transform: "rotate(180deg)" }} />

                                        {!assignedParticipant &&
                                            <span className={styles.deskNumber} style={{ width: deskHeight / 4, height: deskHeight / 4, top: deskHeight / 5.8 }}>{desk.number}</span>
                                        }
                                        {assignedParticipant &&
                                            <div onMouseDown={(e) => {
                                                if (!currentRoomAdmin || currentRoomAdmin?._id === currentUser?._id || currentRoomAdmin?._id === currentParticipant?._id) {
                                                    setSelectedParticipant(assignedParticipant)
                                                    handleMouseDown(e, assignedParticipant)
                                                }

                                            }}
                                                onTouchStart={(e) => {
                                                    if (!currentRoomAdmin || currentRoomAdmin?._id === currentUser?._id || currentRoomAdmin?._id === currentParticipant?._id) {
                                                        setSelectedParticipant(assignedParticipant)
                                                        handleMouseDown(e, assignedParticipant)
                                                    }

                                                }}
                                                style={{
                                                    top: 0, left: 0, width: deskWidth, height: deskHeight, position: "absolute",
                                                    touchAction: currentParticipant?._id === assignedParticipant.participant._id ? "none" : "",
                                                    userSelect: currentParticipant?._id === assignedParticipant.participant._id ? "none" : "",
                                                    pointerEvents: currentParticipant?._id === assignedParticipant.participant._id ? "none" : "",
                                                }}
                                            >
                                                <ParticipantDragComponent user={assignedParticipant.participant} isOnline={assignedParticipant.isOnline} scale={deskHeight / 570}
                                                    deskNumber={desk.number} />
                                            </div>
                                        }
                                    </div>
                                )

                            })}
                            {
                                displayedRoom?.desks_south.length > 0 && displayedRoom?.desks_east.length > 0 &&
                                <img alt={"img"} src={CornerImage} height={deskHeight} style={{ transform: "rotate(180deg)" }} />
                            }
                        </div>
                    </div>
                </div>}
                {isRemote &&
                    <>
                        <div ref={tableRef} style={{ height: "100%", width: "100%", display: "flex", justifyContent: "center", alignItems: "center" }}>
                            <img src={remoteImage} className={styles.remoteImage} alt={'remote'} />
                        </div>

                        <label className={styles.boldRemoteText} style={{ top: remotePlusRef?.current ? remotePlusRef?.current.getBoundingClientRect().y / oyDivider + 280 : "62.5%" }}>
                            Add & Invite {currentConferenceRef.current?.type !== "Meeting" ? "Remote" : ""} Users
                        </label>
                        <label className={styles.thinRemoteText} style={{ top: remotePlusRef?.current ? remotePlusRef?.current.getBoundingClientRect().y / oyDivider + 370 : "66%" }}>
                            Drag users into this area to include them in the conference. Participants are selected to receive an email invitation by default. Tap to deselect if necessary.
                        </label>

                        <div className={styles.buttonsBottom}>
                            <DarkButtonComponent style={{ width: 369 }} onClick={selectAllInvites}>
                                Select All
                            </DarkButtonComponent>
                            <DarkButtonComponent style={{ width: 414 }} onClick={deselectAllInvites}>
                                Deselect All
                            </DarkButtonComponent>
                            <LightButtonComponent style={{ marginLeft: 0, borderRadius: 8, opacity: disabled ? 0.4 : 1 }} onClick={sendInvites} disabled={disabled}>
                                <FontAwesomeIcon className={styles.icon} icon={byPrefixAndName.fas['paper-plane-top']} />Send Invites
                            </LightButtonComponent>
                        </div>
                        <div ref={ref} className={styles.remoteComponent} style={{ pointerEvents: "none" }}>
                            {attachedParticipants.map((attachedParticipant) => {

                                const videos = participantsStreams.find((stream) => stream.participant._id === attachedParticipant?.participant._id)

                                if (videos) {
                                    attachedParticipant.isOnline = true
                                }

                                return (
                                    <div key={attachedParticipant._id} style={{ position: "relative", width: 480, height: 387, marginRight: 80, pointerEvents: "all" }}>
                                        <div
                                            onPointerDown={(e) => {
                                                setSelectedParticipant(attachedParticipant);
                                                handlePointerDown(e, attachedParticipant);
                                            }}
                                            style={{ top: 0, left: 0, width: 480, height: 387, position: "absolute" }}
                                        >
                                            <ParticipantDragComponent user={attachedParticipant.participant} scale={1} emailSent={attachedParticipant.emailSent}
                                                border={selectedInvites.includes(attachedParticipant.participant._id) ? "4px solid #33FFC8" : "4px solid #3F3857"} />
                                        </div>
                                    </div>)
                            })}
                            <div ref={remotePlusRef} className={styles.remotePlus}>
                                <FontAwesomeIcon className={styles.plus} icon={byPrefixAndName.fas['plus']} />
                            </div>
                        </div>

                    </>
                }


            </div>


        </>
    );

}

export default DisplayRoomComponent;
